import request from '@/utils/request'

/**
 * 分页查询通道切换历史
 * @param {Object} params - 查询参数
 * @param {Number} params.page - 当前页码，从1开始
 * @param {Number} params.limit - 每页显示记录数
 * @param {String} [params.order] - 排序方式(asc/desc)
 * @param {String} [params.orderField] - 排序字段
 * @param {String} [params.orderCode] - 订单号（支持模糊查询）
 * @param {String} [params.merchantType] - 商户类型
 * @param {Number} [params.isSuccess] - 是否成功(0=失败,1=成功)
 * @returns {Promise}
 */
export function getChannelSwitchHistoryPage(params) {
  return request({
    url: '/payOrder/channelSwitchHistory/page',
    method: 'get',
    params: params
  })
}

/**
 * 根据订单号查询通道切换历史
 * @param {String} orderCode - 订单号
 * @returns {Promise}
 */
export function getChannelSwitchHistoryByOrderCode(orderCode) {
  return request({
    url: `/payOrder/channelSwitchHistory/listByOrderCode/${orderCode}`,
    method: 'get'
  })
}
